import React from "react";
import "../css/SummarySection.css";

const SummarySection = () => {
  const annualReports = [
    { year: "2019", url: "wp-content/uploads/2020/08/Dockyard_AR_2019.pdf" },
    { year: "2020", url: "wp-content/uploads/2021/04/Dockyard_AR_2020.pdf" },
    { year: "2021", url: "wp-content/uploads/2022/06/Annual_Report_2021.pdf" },
    { year: "2022", url: "wp-content/uploads/2022/WE/Annual_Report_2022.pdf" },
    { year: "2023", url: "wp-content/uploads/2024/06/Annual_Report_2023.pdf" },
    { year: "2024", url: "wp-content/uploads/2024/13/Annual_Report_2024.pdf" },
  ];

  const arrowImg = (
    <img
      src="/wp-content/themes/cdl/images/box-arrow.png"
      alt="arrow"
      className="summary-arrow"
    />
  );

  return (
    <section id="summery-sec">
      <div className="center-container">
        <div className="summary-grid">
          {/* Blog - left col */}
          <div data-aos="fade-right" className="summary-col">
            <div className="summary-card blog-card-inner" style={{ backgroundImage: "url('/wp-content/themes/cdl/images/blog-bg.jpg')" }}>
              <div className="summary-card-overlay" />
              <div className="summary-card-content">
                <div>
                  <h2 className="summary-card-title">BLOG</h2>
                  <h3 className="summary-card-body-title">
                    <a href="blog-news.html" className="summary-card-link">
                      COLOMBO DOCKYARD LAYS FOUNDATION STONE TO BUILD A FULLY
                      FLEDGED ENGINEERING WORKSHOP AT HAMBANTOTA INTERNATIONAL PORT
                    </a>
                  </h3>
                  <small className="summary-card-date">August 22, 2024</small>
                </div>
                <a href="/blog-news" className="summary-card-arrow">{arrowImg}</a>
              </div>
            </div>
          </div>

          {/* Middle col - two stacked */}
          <div data-aos="fade-up" data-aos-delay="150" className="summary-col summary-col-stack">
            {/* Sustainability */}
            <div className="summary-sub-card" style={{ background: "#3970f3" }}>
              <div>
                <img src="/wp-content/themes/cdl/images/sustanability-img.png" alt="sustainability" className="summary-icon" />
                <h3 className="summary-sub-title">SUSTAINABILITY</h3>
                <p className="summary-sub-text">
                  Corporate sustainability practices at Colombo Dockyard PLC (CDPLC) is of extreme importance and given due prominence.
                </p>
              </div>
              <a href="/sustainability" className="summary-card-arrow">{arrowImg}</a>
            </div>

            {/* Our People */}
            <div className="summary-sub-card summary-bg-card" style={{ backgroundImage: "url('/wp-content/themes/cdl/images/our-people-bg.jpg')" }}>
              <div className="summary-card-overlay" />
              <div className="summary-card-content">
                <div>
                  <img src="/wp-content/themes/cdl/images/people-img.png" alt="Our People" className="summary-icon" />
                  <h3 className="summary-sub-title">OUR PEOPLE</h3>
                  <p className="summary-sub-text">
                    From our inception, Colombo Dockyard has prided itself as a 'people oriented' organisation.
                  </p>
                </div>
                <a href="/recognition-of-employees.html" className="summary-card-arrow">{arrowImg}</a>
              </div>
            </div>
          </div>

          {/* Right col - two stacked */}
          <div data-aos="fade-left" data-aos-delay="300" className="summary-col summary-col-stack">
            {/* Careers */}
            <div className="summary-sub-card" style={{ background: "#c2185b" }}>
              <div>
                <img src="/wp-content/themes/cdl/images/careers-img.png" alt="Careers" className="summary-icon" />
                <h3 className="summary-sub-title">CAREERS</h3>
                <p className="summary-sub-text">
                  Colombo Dockyard has exciting opportunities for motivated and qualified individuals to join our team.
                </p>
              </div>
              <a href="/opportunities.html" className="summary-card-arrow">{arrowImg}</a>
            </div>

            {/* Annual Reports + Stock */}
            <div className="summary-bottom-grid">
              {/* Annual Reports */}
              <div className="summary-bottom-card" style={{ background: "#6a1b9a" }}>
                <div>
                  <div className="summary-bottom-header">
                    <img src="/wp-content/themes/cdl/images/annuel-report-img.png" alt="Annual Reports" className="summary-icon-sm" />
                    <h3 className="summary-bottom-title">ANNUAL REPORTS</h3>
                  </div>
                  <div>
                    {annualReports.map((report, index) => (
                      <a key={index} href={report.url} className="summary-report-link">
                        ↓ Annual Reports {report.year}
                      </a>
                    ))}
                  </div>
                </div>
                <a href="home-annual-reports" className="summary-card-arrow">
                  <img src="/wp-content/themes/cdl/images/box-arrow.png" alt="arrow" className="summary-arrow-sm" />
                </a>
              </div>

              {/* Stock Updates */}
              <div className="summary-bottom-card summary-bg-card" style={{ backgroundImage: "url('/wp-content/themes/cdl/images/stock-market.png')" }}>
                <div className="summary-card-overlay" />
                <div className="summary-card-content">
                  <div>
                    <div className="summary-bottom-header">
                      <img src="/wp-content/themes/cdl/images/stock-update-img.png" alt="Stock Updates" className="summary-icon-sm" />
                      <h3 className="summary-bottom-title">STOCK UPDATES</h3>
                    </div>
                    <p className="summary-sub-text" style={{ marginTop: 8 }}>
                      See the stock market performance for Colombo Dockyard PLC
                    </p>
                  </div>
                  <a href="https://www.cse.lk/company-profile?symbol=DOCK.N0000" target="_blank" rel="noopener noreferrer" className="summary-card-arrow">
                    <img src="/wp-content/themes/cdl/images/box-arrow.png" alt="arrow" className="summary-arrow-sm" />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SummarySection;
